import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import { useToasts } from '@/hooks/useToasts'
import { useTranslation } from 'react-i18next'

import {
  useDeleteFacilityMutation,
  useFacilityUnresolvedIncidentsQuery,
} from '@/graphql/generated/hooks'

interface UseDeleteFacilityIProps {
  id: string
  onClose: () => void
}

export const useDeleteFacility = ({ id, onClose }: UseDeleteFacilityIProps) => {
  const { t } = useTranslation()
  // deleteFacility has always been a backend soft-delete (archive with
  // cascade); the flag only changes how the flow is presented to the user.
  const isArchivePresentation = useFeatureFlag(
    FeatureFlag.archiveFloorAndFacility
  )
  const [deleteFacilityMutation, { loading: isDeleteLoading }] =
    useDeleteFacilityMutation()
  const { showSuccess, showError } = useToasts()
  const {
    data,
    error,
    loading: isQueryLoading,
  } = useFacilityUnresolvedIncidentsQuery({
    variables: {
      id,
    },
    fetchPolicy: 'network-only',
  })

  const deleteFacility = async () => {
    try {
      await deleteFacilityMutation({
        variables: {
          input: {
            id,
          },
        },
        refetchQueries: ['FacilitiesTable'],
      })
      showSuccess(
        isArchivePresentation
          ? t('facilities:archive_success')
          : 'Facility removed.'
      )
      onClose()
    } catch (error) {
      showError()
    }
  }

  return {
    deleteFacility,
    data: data?.facility,
    hasUnresolvedIncidents: data?.facility.incidents?.totalCount > 0,
    //loading: isQueryLoading || isDeleteLoading,
    dataLoaded: !isQueryLoading || (!isDeleteLoading && data),
    error,
  }
}
